import { memo, type ReactNode } from 'react';

import { Content } from '~/components/AssetModal/Panel/Content/Content';
import {
  ContentHeader,
  type ContentHeaderProps,
} from '~/components/AssetModal/Panel/Content/ContentHeader/ContentHeader';

export type AssetModalPanelContainerProps = {
  title: ContentHeaderProps['title'];
  adornment?: ContentHeaderProps['adornment'];
  contentHeader?: ContentHeaderProps['contentHeader'];
  panel: ReactNode;
};

export const AssetModalPanelContainer = memo(
  ({ title, adornment, contentHeader, panel }: AssetModalPanelContainerProps) => {
    return (
      <Content>
        <ContentHeader title={title} adornment={adornment} contentHeader={contentHeader} />
        <div className="flex w-full grow flex-col md:overflow-auto">{panel}</div>
      </Content>
    );
  },
);

AssetModalPanelContainer.displayName = 'AssetModalPanelContainer';
